module.exports = __webpack_public_path__ + "img/herat.2b3cae63.jpg";